<template>
  <div>
    <div v-if="!loading">
      <div class="text-gray-600 mb-4" v-if="!error">
        <div v-if="tgSettings != null">
          <p class="text-gray-400 mb-1">botName: {{tgSettings.botName}}</p>
          <p class="text-gray-400 mb-1">isRegistered: {{tgSettings.isRegistered}}</p>

          <p class="text-gray-400 mb-1">botToken: {{tgSettings.botToken}}</p>
          <!-- {{ tgSettings }}-->
        </div>
        <div v-else>
          no
        </div>
      </div>
      <div class="text-red-600" v-else>
        Ошибка
      </div>
    </div>
    <LoaderIcon v-else/>
  </div>
</template>

<script>
import LoaderIcon from "@/components/LoaderIcon.vue";

export default {
  name: 'TgBotSettingsBlock',
  components: {LoaderIcon},
  data() {
    return {
      tgSettings: null,
      error: null,
      loading: true
    }
  },
  mounted() {
    this.loadData();
  },
  computed: {
    /*tokenExist: function () {
      return this.tgSettings?.id > 0;
    }*/
  },
  methods: {
    loadData: function () {
      console.log("load email service settings");
      let c = this;
      c.tgSettings = null;
      c.loading = true;
      c.error = false;
      this.axios.get('/api/admin/tg/settings').then(function(response) {
        console.log(response.data);
        c.tgSettings = response.data.data;
        c.loading = false;
      }).catch(function(err) {
        console.log(err.status);
        c.loading = false;
        c.error = true;
      });
    }
  }
}
</script>

<style scoped>

</style>